import { useState } from 'react';

const menuItems = [
  {
    name: 'المخبوزات الطازجة',
    description: 'تشكيلة متنوعة من الكرواسون الفرنسي، الدانش، المافن، والخبز الطازج المحضر يوميًا في مخابزنا',
    image: 'https://public.readdy.ai/ai/img_res/b7f2e9b5c64e78d62cb61e418cafa4d5.jpg'
  },
  {
    name: 'الأطباق الساخنة',
    description: 'بيض مطبوخ بطرق متعددة، فول، حمص، فلافل، وتشكيلة من الأطباق الساخنة المحلية والعالمية',
    image: 'https://readdy.ai/api/search-image?query=Hot%20breakfast%20dishes%20with%20eggs%20prepared%20multiple%20ways%2C%20falafel%20hummus%20and%20warm%20traditional%20dishes%2C%20elegant%20hotel%20restaurant%20plating%2C%20professional%20food%20photography%20with%20clean%20simple%20white%20background%2C%20appetizing%20presentation&width=600&height=400&seq=menu2&orientation=landscape'
  },
  {
    name: 'الأجبان والألبان',
    description: 'تشكيلة فاخرة من الأجبان المحلية والعالمية، اللبنة، الزبادي، والقشطة الطازجة',
    image: 'https://readdy.ai/api/search-image?query=Premium%20cheese%20and%20dairy%20selection%20on%20elegant%20serving%20board%2C%20variety%20of%20local%20and%20international%20cheeses%20labneh%20yogurt%2C%20luxury%20hotel%20breakfast%20spread%2C%20professional%20food%20photography%20with%20clean%20simple%20white%20background%2C%20sophisticated%20presentation&width=600&height=400&seq=menu3&orientation=landscape'
  },
  {
    name: 'الفواكه الطازجة',
    description: 'فواكه موسمية طازجة مقطعة بعناية، سلطة فواكه، وعصائر طبيعية محضرة طازجة',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20seasonal%20fruits%20beautifully%20arranged%2C%20fruit%20salad%20and%20natural%20juices%2C%20colorful%20healthy%20breakfast%20options%2C%20luxury%20hotel%20buffet%20display%2C%20professional%20food%20photography%20with%20clean%20simple%20white%20background%2C%20vibrant%20fresh%20presentation&width=600&height=400&seq=menu4&orientation=landscape'
  },
  {
    name: 'الحلويات الشرقية',
    description: 'تشكيلة من الحلويات العربية التقليدية، الكنافة، القطايف، والمعمول المحضر بوصفات أصيلة',
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Arabic%20sweets%20and%20desserts%20elegantly%20displayed%2C%20kunafa%20qatayef%20maamoul%20pastries%2C%20luxury%20hotel%20breakfast%20buffet%2C%20professional%20food%20photography%20with%20clean%20simple%20white%20background%2C%20golden%20honey%20drizzle%20presentation&width=600&height=400&seq=menu5&orientation=landscape'
  },
  {
    name: 'المشروبات الساخنة',
    description: 'قهوة عربية أصيلة، إسبريسو إيطالي، شاي بأنواعه، وشوكولاتة ساخنة فاخرة',
    image: 'https://readdy.ai/api/search-image?query=Premium%20hot%20beverages%20selection%20with%20Arabic%20coffee%20espresso%20tea%20and%20hot%20chocolate%2C%20elegant%20hotel%20service%20presentation%2C%20professional%20food%20photography%20with%20clean%20simple%20white%20background%2C%20steam%20rising%20from%20cups&width=600&height=400&seq=menu6&orientation=landscape'
  }
];

const lunchDinnerItems = [
  {
    name: 'المقبلات الشرقية',
    description: 'حمص، متبل، فتوش، تبولة، وتشكيلة من المقبلات اللبنانية الأصيلة',
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Middle%20Eastern%20mezze%20platter%20with%20hummus%20baba%20ganoush%20fattoush%20tabbouleh%2C%20elegant%20restaurant%20presentation%2C%20professional%20food%20photography%20with%20clean%20simple%20white%20background%2C%20colorful%20fresh%20ingredients&width=600&height=400&seq=lunch1&orientation=landscape'
  },
  {
    name: 'الأطباق الرئيسية',
    description: 'مشاوي مشكلة، كبسة، مندي، برياني، وأطباق عالمية متنوعة محضرة بعناية',
    image: 'https://readdy.ai/api/search-image?query=Grilled%20mixed%20meats%20kabsa%20mandi%20biryani%20main%20course%20dishes%2C%20luxury%20hotel%20restaurant%20plating%2C%20professional%20food%20photography%20with%20clean%20simple%20white%20background%2C%20appetizing%20presentation%20with%20garnish&width=600&height=400&seq=lunch2&orientation=landscape'
  },
  {
    name: 'المأكولات البحرية',
    description: 'سمك مشوي، جمبري، كاليماري، وتشكيلة من المأكولات البحرية الطازجة',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20seafood%20selection%20with%20grilled%20fish%20shrimp%20calamari%2C%20elegant%20restaurant%20presentation%2C%20professional%20food%20photography%20with%20clean%20simple%20white%20background%2C%20premium%20quality%20ingredients&width=600&height=400&seq=lunch3&orientation=landscape'
  },
  {
    name: 'المعكرونة والبيتزا',
    description: 'معكرونة إيطالية أصيلة، بيتزا بعجينة طازجة، وأطباق إيطالية كلاسيكية',
    image: 'https://readdy.ai/api/search-image?query=Italian%20pasta%20and%20pizza%20dishes%20with%20fresh%20ingredients%2C%20elegant%20restaurant%20plating%2C%20professional%20food%20photography%20with%20clean%20simple%20white%20background%2C%20authentic%20Italian%20cuisine%20presentation&width=600&height=400&seq=lunch4&orientation=landscape'
  },
  {
    name: 'السلطات الطازجة',
    description: 'سلطة سيزر، سلطة يونانية، سلطة الكينوا، وتشكيلة من السلطات الصحية',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20healthy%20salads%20with%20caesar%20greek%20quinoa%20varieties%2C%20elegant%20bowl%20presentation%2C%20professional%20food%20photography%20with%20clean%20simple%20white%20background%2C%20colorful%20vegetables%20and%20greens&width=600&height=400&seq=lunch5&orientation=landscape'
  },
  {
    name: 'الحلويات الفاخرة',
    description: 'تيراميسو، كريم بروليه، تشيز كيك، وحلويات عالمية متنوعة',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20desserts%20with%20tiramisu%20creme%20brulee%20cheesecake%2C%20elegant%20plating%20presentation%2C%20professional%20food%20photography%20with%20clean%20simple%20white%20background%2C%20sophisticated%20sweet%20treats&width=600&height=400&seq=lunch6&orientation=landscape'
  }
];

const beverageItems = [
  {
    name: 'القهوة الخاصة',
    description: 'قهوة عربية، إسبريسو، كابتشينو، لاتيه، وتشكيلة من المشروبات الساخنة المختصة',
    image: 'https://readdy.ai/api/search-image?query=Specialty%20coffee%20selection%20with%20Arabic%20coffee%20espresso%20cappuccino%20latte%2C%20elegant%20cafe%20presentation%2C%20professional%20food%20photography%20with%20clean%20simple%20white%20background%2C%20steam%20rising%20from%20elegant%20cups&width=600&height=400&seq=beverage1&orientation=landscape'
  },
  {
    name: 'العصائر الطازجة',
    description: 'عصائر طبيعية طازجة، سموذي، وكوكتيلات فواكه محضرة يوميًا',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20natural%20juices%20and%20smoothies%20in%20elegant%20glasses%2C%20colorful%20fruit%20cocktails%2C%20professional%20beverage%20photography%20with%20clean%20simple%20white%20background%2C%20vibrant%20healthy%20drinks&width=600&height=400&seq=beverage2&orientation=landscape'
  },
  {
    name: 'الشاي والمشروبات العشبية',
    description: 'شاي أحمر، أخضر، أعشاب طبيعية، وتشكيلة من المشروبات المهدئة',
    image: 'https://readdy.ai/api/search-image?query=Herbal%20tea%20selection%20with%20red%20green%20tea%20and%20natural%20herbs%2C%20elegant%20tea%20service%20presentation%2C%20professional%20beverage%20photography%20with%20clean%20simple%20white%20background%2C%20calming%20therapeutic%20drinks&width=600&height=400&seq=beverage3&orientation=landscape'
  },
  {
    name: 'المشروبات الباردة',
    description: 'مشروبات غازية، مياه منكهة، آيس تي، وكوكتيلات باردة منعشة',
    image: 'https://readdy.ai/api/search-image?query=Cold%20refreshing%20beverages%20with%20flavored%20water%20iced%20tea%20and%20cold%20cocktails%2C%20elegant%20glass%20presentation%2C%20professional%20beverage%20photography%20with%20clean%20simple%20white%20background%2C%20refreshing%20summer%20drinks&width=600&height=400&seq=beverage4&orientation=landscape'
  }
];

export default function Menu() {
  const [activeTab, setActiveTab] = useState('breakfast');

  const tabs = [
    {
      id: 'breakfast',
      name: 'بوفيه الفطور المفتوح',
      icon: 'ri-restaurant-line',
      items: menuItems,
      time: 'من 6:30 صباحًا - 11:00 صباحًا',
      color: 'from-teal-500 to-teal-600',
      link: '/breakfast'
    },
    {
      id: 'lunch-dinner',
      name: 'وجبات الغداء والعشاء',
      icon: 'ri-restaurant-2-line',
      items: lunchDinnerItems,
      time: 'من 12:00 ظهرًا - 11:00 مساءً',
      color: 'from-orange-500 to-orange-600',
      link: '/lunch-dinner'
    },
    {
      id: 'beverages',
      name: 'الكافي والمشروبات',
      icon: 'ri-cup-line',
      items: beverageItems,
      time: 'على مدار ٢٤ ساعة',
      color: 'from-amber-500 to-amber-600',
      link: '/beverages'
    }
  ];

  const currentTab = tabs.find(tab => tab.id === activeTab);

  return (
    <section id="menu" className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6" style={{ fontFamily: 'Cairo, sans-serif' }}>
            قوائم مطعم فوكاتشيا
          </h2>
          <div className="w-32 h-1 bg-gradient-to-r from-teal-500 to-orange-500 mx-auto mb-8"></div>
          <p className="text-xl text-gray-700 leading-relaxed max-w-3xl mx-auto">
            اكتشف تشكيلة واسعة من الأطباق المميزة - بوفيه فطور مفتوح يوميًا وقوائم متنوعة للغداء والعشاء، مع خدمة الكافي على مدار ٢٤ ساعة
          </p>
        </div>

        {/* Tabs Navigation */}
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`group flex items-center gap-3 px-8 py-4 rounded-full transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer ${
                activeTab === tab.id
                  ? `bg-gradient-to-r ${tab.color} text-white shadow-lg`
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              <i className={`${tab.icon} text-xl`}></i>
              <div className="text-right">
                <div className="font-bold text-lg" style={{ fontFamily: 'Cairo, sans-serif' }}>
                  {tab.name}
                </div>
                <div className="text-sm opacity-90">
                  {tab.time}
                </div>
              </div>
            </button>
          ))}
        </div>

        {/* Tab Content */}
        <div className="max-w-7xl mx-auto">
          {currentTab && (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {currentTab.items.map((item, index) => (
                <div
                  key={index}
                  className="group bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
                >
                  <div className="relative w-full h-64 overflow-hidden">
                    <img
                      src={item.image}
                      alt={item.name}
                      className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  </div>
                  <div className="p-6">
                    <h3 className="text-xl font-bold text-gray-900 mb-3" style={{ fontFamily: 'Cairo, sans-serif' }}>
                      {item.name}
                    </h3>
                    <p className="text-base text-gray-600 leading-relaxed">
                      {item.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* View Full Menu Button */}
        <div className="text-center mt-12">
          {currentTab && (
            <a
              href={currentTab.link}
              className={`inline-flex items-center gap-3 px-8 py-4 rounded-full bg-gradient-to-r ${currentTab.color} text-white font-bold text-lg transition-all duration-300 transform hover:scale-105 hover:shadow-lg cursor-pointer whitespace-nowrap`}
              style={{ fontFamily: 'Cairo, sans-serif' }}
            >
              <span>عرض القائمة الكاملة مع الأسعار</span>
              <i className="ri-arrow-left-line text-xl"></i>
            </a>
          )}
        </div>

        <div className="text-center mt-16">
          <div className="inline-block bg-gradient-to-r from-teal-50 to-orange-50 rounded-2xl p-8">
            <div className="flex items-center gap-4 justify-center mb-4">
              <i className="ri-time-line text-3xl text-teal-600"></i>
              <h3 className="text-2xl font-bold text-gray-900" style={{ fontFamily: 'Cairo, sans-serif' }}>
                ساعات العمل
              </h3>
            </div>
            <div className="space-y-3">
              <p className="text-lg text-gray-700 font-semibold">
                <span className="text-teal-600">بوفيه الفطور المفتوح:</span> يوميًا من 6:30 ص - 11:00 ص
              </p>
              <p className="text-lg text-gray-700 font-semibold">
                <span className="text-orange-600">الغداء والعشاء:</span> يوميًا من 12:00 م - 11:00 م
              </p>
              <p className="text-lg text-gray-700 font-semibold">
                <span className="text-amber-600">الكافي والمشروبات:</span> على مدار ٢٤ ساعة
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}